import React from 'react'
import type { MetaDataHighlight, SearchResultRace } from '@core/Areas/Search/types'
import { ResultContentListRow } from '@core/Areas/Search/Components/Common/ResultContentListRow'
import { HighlightDisplay } from '@core/Areas/Search/Components/Common/HighlightDisplay'
import { LocationTime } from '../Common/LocationTime'

export const RaceResult: React.FC<{
  searchResult: SearchResultRace
  highlights: MetaDataHighlight
}> = ({ searchResult, highlights: tokens }) => {
  const { race } = searchResult
  const advertisedStartTime = race.isStartTimeRelevant ? race.advertisedStartTime : undefined

  return (
    <ResultContentListRow
      testId='SearchResultRace'
      topContent={
        <LocationTime
          locationName={race.fixture.name}
          raceNumber={race.number}
          advertisedStartTime={advertisedStartTime}
          code={race.fixture.contestType}
          status={race.status}
          highlightKey='race.fixture.name'
          highlights={tokens}
        />
      }
      primaryText={
        <HighlightDisplay
          displayText={race.name}
          highlightKey='race.name'
          highlights={searchResult.metadata.highlights}
        />
      }
      secondaryText={
        <>
          <span>{race.distance}m</span>
          <span>
            <HighlightDisplay
              displayText={race.class}
              highlightKey='race.class'
              highlights={searchResult.metadata.highlights}
            />
          </span>
        </>
      }
    />
  )
}
